@if (
  (label() && !isMultiLookup()) ||
  (label() && isMultiLookup() && inputFormControlName() === 0)
) {
  <div
    class="flex justify-between items-center"
    [class.mb-x-sm]="selectedOption()">
    <div class="flex gap-x-sm items-baseline">
      <label
        class="block font-medium text-sm"
        [class.cursor-not-allowed]="childControl.disabled"
        [class.text-neutral-300]="childControl.disabled"
        [class.cursor-pointer]="!childControl.disabled && !viewOnly()"
        [class.text-neutral-900]="!childControl.disabled && !viewOnly()"
        [class.text-neutral-500]="viewOnly()"
        [class.text-xs2]="viewOnly()"
        [class.mb-x-sm]="!viewOnly() && !selectedOption()"
        [class.label-required]="required()"
        [class]="labelClass()">
        {{ label() }}
      </label>
      @if (labelBadge()) {
        <ng-container [ngTemplateOutlet]="labelBadge()"></ng-container>
      }
    </div>
  </div>
}

<!-- Select Container -->
@if (!selectedOption() && !viewOnly()) {
  <div class="relative">
    <div
      class="select flex items-center w-full border border-neutral-300 rounded-md text-sm p-md"
      dropdownOverlay
      [(isOpen)]="lookupDropdownOpen"
      [disabled]="childControl.disabled"
      [matchWidth]="!isParentChildTriggerLookup()"
      [positions]="dropdownListPositions"
      popupRole="listbox"
      [clickOutside]="true"
      [attr.tabindex]="childControl.disabled ? -1 : 0"
      [attr.aria-disabled]="childControl.disabled || null"
      [class.cursor-not-allowed]="childControl.disabled"
      [class.text-neutral-300]="childControl.disabled"
      [class.font-medium]="!childControl.disabled"
      [class.cursor-pointer]="!childControl.disabled"
      [class.focus]="lookupDropdownOpen()"
      [class.text-neutral-900]="
        !childControl.disabled &&
        !(childControl.touched && childControl.dirty && childControl.errors)
      "
      [class.has-errors]="
        childControl.touched && childControl.dirty && childControl.errors
      "
      [class.text-destructive-900]="
        childControl.touched && childControl.dirty && childControl.errors
      "
      [class]="inputClass()">
      <span
        [style.cursor]="childControl.disabled ? 'not-allowed' : ''"
        class="bg-transparent text-sm w-full pe-2xl font-normal"
        [class.text-neutral-300]="childControl.disabled"
        [class.text-neutral-400]="!childControl.disabled && !value()"
        [class.text-neutral-900]="!childControl.disabled && value()">
        {{ placeholder() }}
      </span>

      <div
        class="flex"
        [class]="
          childControl.disabled ? 'cursor-not-allowed' : 'cursor-pointer'
        "
        [attr.disabled]="childControl.disabled">
        <lib-chevron-down-icon
          iconClass="size-5"
          stroke="var(--color-neutral-500)" />
      </div>

      <ng-template #dropdownContent let-close="close">
        <div
          class="text-start py-2xl bg-white shadow-md rounded-lg"
          [class.w-full]="!isParentChildTriggerLookup()"
          [class.min-w-0]="!isParentChildTriggerLookup()"
          [class.dropdown-list--parent-child]="isParentChildTriggerLookup()">
          @if (isParentChildTriggerLookup()) {
            <div
              class="flex items-center justify-between gap-md mx-lg mb-lg pb-lg border-b border-neutral-200">
              <h5 class="text-neutral-900 font-semibold text-xl">
                {{ label() || placeholder() }}
              </h5>
              <button
                type="button"
                id="lookup_field_trigger_action_button"
                class="flex items-center shrink-0 bg-primary-500 text-white font-medium text-sm py-sm px-xl border-none rounded-md gap-sm cursor-pointer hover:bg-primary-600"
                (click)="
                  onTriggerActionClick(triggerAction()!, $event); close()
                ">
                {{ 'request_details_screen_trigger_button_label' | transloco }}
                <lib-arrow-left-icon
                  [iconClass]="'size-5 text-white rotate-180'"
                  [width]="'20'"
                  [height]="'20'" />
              </button>
            </div>
          }
          @if (filters().length) {
            <div class="mx-lg mb-sm pb-sm border-b border-neutral-200">
              <!-- search input -->
              <div class="flex flex-col gap-x-sm">
                <label
                  class="select w-full flex items-center border border-neutral-300 rounded-md text-sm p-md relative"
                  [class.cursor-not-allowed]="childControl.disabled"
                  [class.text-neutral-300]="childControl.disabled"
                  [class.font-medium]="!childControl.disabled"
                  [class.cursor-pointer]="!childControl.disabled"
                  [class.text-neutral-900]="!childControl.disabled"
                  [class.focus]="lookupDropdownOpen()">
                  <input
                    type="text"
                    [id]="id()"
                    [readOnly]="readonly() || !isSearchable()"
                    [value]="searchKeyword()"
                    (input)="onSearchInputChange($any($event.target).value)"
                    (keydown)="$event.stopPropagation()"
                    (mousedown)="$event.stopPropagation()"
                    [required]="required()"
                    [placeholder]="searchPlaceholder()"
                    [style.cursor]="childControl.disabled ? 'not-allowed' : ''"
                    class="bg-transparent text-base w-full pe-2xl text-neutral-900" />

                  <div
                    class="icon absolute end-3 inset-y-3 cursor-pointer"
                    [attr.disabled]="childControl.disabled">
                    @if (isSearchable()) {
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 20 20"
                        fill="none">
                        <path
                          d="M9.58268 17.4993C13.9549 17.4993 17.4993 13.9549 17.4993 9.58268C17.4993 5.21043 13.9549 1.66602 9.58268 1.66602C5.21043 1.66602 1.66602 5.21043 1.66602 9.58268C1.66602 13.9549 5.21043 17.4993 9.58268 17.4993Z"
                          stroke="#6B7280"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round" />
                        <path
                          d="M18.3327 18.3327L16.666 16.666"
                          stroke="#6B7280"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round" />
                      </svg>
                    } @else {
                      <lib-chevron-down-icon
                        iconClass="size-4"
                        stroke="var(--color-neutral-500)" />
                    }
                  </div>
                </label>
              </div>
            </div>
          }

          <div
            class="dropdown-list"
            [class.pointer-events-none]="isSelectingAll()"
            (scroll)="onScroll($event)">
            @if (showSelectAll()) {
              <div class="border-b border-neutral-200">
                <button
                  type="button"
                  [id]="id() + '_select_all'"
                  class="dropdown-item w-full cursor-pointer px-3 py-4 hover:bg-neutral-50 text-start border-none bg-transparent"
                  [disabled]="isLoading() || isSelectingAll()"
                  (click)="selectAllFromDropdown()">
                  <span class="text-sm font-semibold text-primary-600">
                    {{ selectAllLabel() }}
                  </span>
                </button>
              </div>
            }
            <!-- search result -->
            @if (!showNoSearchResult()) {
              @for (
                option of filteredOptions.length ? filteredOptions : options();
                track option[selectedKeyValue()]
              ) {
                @if (isParentChildTriggerLookup()) {
                  <!-- parent child trigger droplist new design -->
                  <div
                    class="dropdown-item cursor-pointer px-lg py-sm"
                    (click)="selectOption(option, true); close()">
                    <div
                      class="border border-neutral-200 rounded-lg px-md py-lg w-full">
                      <div class="flex items-center gap-sm mb-lg">
                        <lib-avatar
                          [imgDimensions]="{ width: 32, height: 32 }"
                          [img]="option.image?.url ?? ''"
                          [fullName]="option[selectedKeyName()] ?? option.label"
                          [size]="''"
                          [borderRadius]="'rounded-full'"
                          class="shrink-0" />
                        <span
                          class="text-sm font-semibold text-neutral-900 line-clamp-2"
                          libTrimTooltip
                          placement="top"
                          [toolTipClass]="'bg-white p-md rounded-lg shadow-lg w-auto tooltip-arrow tooltip-arrow-top'"
                          [fullText]="
                            option[selectedKeyName()] ?? option.label
                          ">
                        </span>
                      </div>

                      @if (labelValueAssignList().extraLabels.length) {
                        <div class="grid grid-cols-3 gap-x-lg gap-y-lg">
                          @for (
                            item of labelValueAssignList().extraLabels
                              | slice: 0 : 6;
                            track $index
                          ) {
                            @let extraLabelValue = option | keyValue: item.key;
                            @if (extraLabelValue) {
                              <div>
                                <p class="text-xs font-medium text-neutral-500">
                                  {{ item.label }}
                                </p>

                                @let viewedExtraLabelValue =
                                  item.type === 'date'
                                    ? (extraLabelValue
                                      | date: 'dd-MMM-yyyy hh:mm a')
                                    : extraLabelValue;

                                <p
                                  class="text-sm font-semibold text-neutral-900 mt-x-sm"
                                  libTrimTooltip
                                  placement="top"
                                  [trimLength]="42"
                                  [toolTipClass]="'bg-white p-md rounded-lg shadow-lg w-auto tooltip-arrow tooltip-arrow-top'"
                                  [fullText]="viewedExtraLabelValue ?? ''"></p>
                              </div>
                            }
                          }
                        </div>
                      }
                    </div>
                  </div>
                } @else {
                  <div
                    class="dropdown-item cursor-pointer px-3 py-4 hover:bg-neutral-50"
                    (click)="selectOption(option, true); close()">
                    @if (option) {
                      <div class="flex items-center gap-2">
                        <lib-avatar
                          [imgDimensions]="{ width: 32, height: 32 }"
                          [img]="option.icon?.url ?? option.image?.url ?? ''"
                          [fullName]="option[selectedKeyName()] ?? option.label"
                          [size]="''"
                          [borderRadius]="'rounded-full'"
                          class="shrink-0" />

                        <div class="flex-1 min-w-0">
                          <div class="flex items-center justify-between gap-2">
                            <span
                              class="text-sm font-semibold text-neutral-900 line-clamp-2"
                              libTrimTooltip
                              placement="top"
                              [toolTipClass]="'bg-white p-md rounded-lg shadow-lg w-auto tooltip-arrow tooltip-arrow-top'"
                              [fullText]="
                                option[selectedKeyName()] ?? option.label
                              ">
                            </span>
                            @if (option.state; as status) {
                              <lib-badge
                                [label]="status.label"
                                [badgeClass]="
                                  'px-sm border-none text-xs font-medium shrink-0 ' +
                                  (status.value | status)
                                " />
                            }
                          </div>
                        </div>
                      </div>

                      @if (labelValueAssignList().extraLabels.length) {
                        <div class="grid grid-cols-2 gap-4 mt-3">
                          @for (
                            item of labelValueAssignList().extraLabels
                              | slice: 0 : 4;
                            track $index
                          ) {
                            @let extraLabelValue = option | keyValue: item.key;
                            @if (extraLabelValue) {
                              <div>
                                <p class="text-xs font-medium text-neutral-500">
                                  {{ item.label }}
                                </p>
                                @let viewedExtraLabelValue =
                                  item.type === 'date'
                                    ? (extraLabelValue
                                      | date: 'dd-MMM-yyyy hh:mm a')
                                    : extraLabelValue;
                                <p
                                  class="text-sm font-semibold text-neutral-900 mt-0.5"
                                  libTrimTooltip
                                  placement="top"
                                  [trimLength]="42"
                                  [toolTipClass]="'bg-white p-md rounded-lg shadow-lg w-auto tooltip-arrow tooltip-arrow-top'"
                                  [fullText]="viewedExtraLabelValue ?? ''"></p>
                              </div>
                            }
                          }
                        </div>
                      }
                    }
                  </div>
                }
              }
              @if (isLoading()) {
                <lib-loader [size]="'sm'"></lib-loader>
              }
            } @else if (!isLoading() && showNoSearchResult()) {
              <div
                class="py-2xl px-lg flex flex-col items-center justify-center gap-lg">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="57"
                  height="56"
                  viewBox="0 0 57 56"
                  fill="none">
                  <path
                    opacity="0.4"
                    d="M27.3327 48.9993C39.575 48.9993 49.4993 39.075 49.4993 26.8327C49.4993 14.5904 39.575 4.66602 27.3327 4.66602C15.0904 4.66602 5.16602 14.5904 5.16602 26.8327C5.16602 39.075 15.0904 48.9993 27.3327 48.9993Z"
                    fill="#D1D5DB" />
                  <path
                    d="M50.2 51.3333C49.78 51.3333 49.36 51.17 49.0566 50.8666L44.7166 46.5266C44.0866 45.8966 44.0866 44.87 44.7166 44.2166C45.3466 43.5866 46.3733 43.5866 47.0266 44.2166L51.3666 48.5566C51.9966 49.1866 51.9966 50.2133 51.3666 50.8666C51.04 51.17 50.62 51.3333 50.2 51.3333Z"
                    fill="var(--color-primary-500)" />
                  <path
                    d="M33.1667 29.0508H21.5C20.5433 29.0508 19.75 28.2574 19.75 27.3008C19.75 26.3441 20.5433 25.5508 21.5 25.5508H33.1667C34.1233 25.5508 34.9167 26.3441 34.9167 27.3008C34.9167 28.2574 34.1233 29.0508 33.1667 29.0508Z"
                    fill="var(--color-primary-500)" />
                </svg>
                {{ noSearchResultLabel() }}
              </div>
            } @else if (isLoading() && showNoSearchResult()) {
              <div
                class="py-2xl px-lg flex flex-col items-center justify-center gap-lg">
                <lib-loader [size]="'sm'"></lib-loader>
              </div>
            }
          </div>

          @if (allowCreate()) {
            <div class="flex justify-end mx-lg pt-sm border-t border-neutral-200">
              <button
                type="button"
                (click)="onCreateNewClick(); close()"
                class="inline-flex items-center gap-x-sm rounded-full border border-primary-100 bg-primary-50 px-md py-x-sm text-sm font-medium text-primary-700 shadow-sm hover:bg-primary-100 cursor-pointer">
                <lib-add-icon iconClass="size-4 text-primary-700" />
                {{ createLabel() }}
              </button>
            </div>
          }
        </div>
      </ng-template>
    </div>
  </div>
} @else if (!selectedOption() && viewOnly() && !relationDetails()) {
  <p class="view-mode-value break-word text-neutral-900">
    {{ detailsNotFoundLabel() }}
  </p>
} @else {
  @let displayOption = selectedOption() ?? relationDetails();

  <!-- Compact selected box (Figma: h-16 / 64px, px-3 / 12px, gap-2 / 8px) -->
  <div
    #selectedBox
    class="relative flex items-center h-16 border border-neutral-200 rounded-lg px-3 gap-2"
    [class.cursor-pointer]="isParentChildTriggerLookup()"
    [attr.role]="isParentChildTriggerLookup() ? 'link' : null"
    (click)="navigateToSelectedRequest(displayOption!)">
    <lib-avatar
      [imgDimensions]="{ width: 32, height: 32 }"
      [img]="displayOption?.icon?.url ?? displayOption?.image?.url ?? ''"
      [fullName]="displayOption?.label ?? ''"
      [size]="''"
      [borderRadius]="'rounded-full'"
      class="shrink-0 self-center" />

    @if (resourceUrl(); as url) {
      <a
        [href]="url"
        target="_blank"
        rel="noopener noreferrer"
        [attr.aria-label]="displayOption?.label ?? ''"
        class="flex-1 text-sm font-semibold hover:text-primary-500 underline! truncate self-center"
        (click)="$event.stopPropagation()"
        libTrimTooltip
        placement="top"
        [toolTipClass]="'bg-white p-md rounded-lg shadow-lg w-auto tooltip-arrow tooltip-arrow-top'"
        [fullText]="
          displayOption?.[selectedKeyName()] ?? displayOption?.label ?? ''
        ">
      </a>
    } @else {
      <span
        class="flex-1 text-sm font-semibold text-neutral-900 truncate self-center"
        libTrimTooltip
        placement="top"
        [toolTipClass]="'bg-white p-md rounded-lg shadow-lg w-auto tooltip-arrow tooltip-arrow-top'"
        [fullText]="
          displayOption?.[selectedKeyName()] ?? displayOption?.label ?? ''
        ">
      </span>
    }

    @if (displayOption?.tag ?? displayOption?.state; as status) {
      <lib-badge
        [label]="status.label"
        [badgeClass]="
          'px-sm border-none text-xs font-medium shrink-0 self-center ' +
          (status.value | status)
        " />
    }

    <!-- Info icon — opens details tooltip in a body-level CDK overlay so no ancestor transform can displace it -->
    <button
      type="button"
      class="bg-transparent border-none p-0 cursor-pointer shrink-0 self-center leading-none"
      dropdownOverlay
      popupRole="dialog"
      [matchWidth]="false"
      [positions]="detailsTooltipPositions"
      #infoBtn
      [closeOnScroll]="true"
      [isOpen]="isDetailsTooltipOpen()"
      (isOpenChange)="
        onDetailsTooltipOpenChange($event, displayOption!, infoBtn)
      "
      (click)="$event.stopPropagation()">
      <lib-info-icon iconClass="size-5 text-primary-500" />
      <ng-template #dropdownContent let-close="close">
        <div
          [id]="'lookup-details-tooltip-' + id()"
          class="relative bg-white rounded-lg shadow-lg !min-w-[31rem] p-2xl text-start"
          [style.transform]="'translateX(' + detailsTooltipShiftPx() + 'px)'"
          (click)="$event.stopPropagation()">
          <ng-container
            [ngTemplateOutlet]="detailsTooltipTemplate"
            [ngTemplateOutletContext]="{ closeTooltip: close }" />
          <span
            class="absolute -bottom-1 size-2 -translate-x-1/2 rotate-45 bg-white"
            [style.left]="
              detailsTooltipArrowLeftPx() === null
                ? '50%'
                : detailsTooltipArrowLeftPx() + 'px'
            "
            aria-hidden="true"></span>
        </div>
      </ng-template>
    </button>

    <!-- Clear/change icon -->
    @if (!viewOnly() && !childControl.disabled) {
      <button
        type="button"
        class="bg-transparent border-none p-0 cursor-pointer shrink-0 self-center leading-none"
        (click)="$event.stopPropagation(); clearSelectedOption()">
        <lib-refresh-icon iconClass="size-5 text-destructive-500" />
      </button>
    }
  </div>

  <!-- Details tooltip template — avatar + name + badge + close on one items-center row, then 2-col label grid -->
  <ng-template #detailsTooltipTemplate let-closeTooltip="closeTooltip">
    <!-- Header: avatar | label | badge | close (all items-center) -->
    <div class="flex items-center gap-sm mb-lg">
      <lib-avatar
        [imgDimensions]="{ width: 40, height: 40 }"
        [img]="displayOption?.icon?.url ?? displayOption?.image?.url ?? ''"
        [fullName]="displayOption?.label ?? ''"
        [size]="''"
        [borderRadius]="'rounded-full'"
        class="shrink-0" />
      <p class="flex-1 min-w-0 text-sm font-semibold text-neutral-900 truncate">
        {{ displayOption?.[selectedKeyName()] ?? displayOption?.label ?? '' }}
      </p>
      @if (displayOption?.tag ?? displayOption?.state; as status) {
        <lib-badge
          [label]="status.label"
          [badgeClass]="
            'px-sm border-none text-xs font-medium shrink-0 ' +
            (status.value | status)
          " />
      }
      @if (closeTooltip) {
        <button
          type="button"
          class="bg-transparent border-none p-0 cursor-pointer shrink-0 leading-none"
          (click)="closeTooltip()">
          <lib-close-icon
            iconClass="size-5"
            stroke="var(--color-neutral-500)" />
        </button>
      }
    </div>
    @if (labelValueAssignList().extraLabels.length) {
      <div class="grid grid-cols-2 gap-3">
        @for (item of labelValueAssignList().extraLabels; track $index) {
          @let extraLabelValue = displayOption | keyValue: item.key;
          @if (extraLabelValue) {
            <div>
              <p class="text-xs font-medium text-neutral-500">
                {{ item.label }}
              </p>
              @let viewedExtraLabelValue =
                item.type === 'date'
                  ? (extraLabelValue | date: 'dd-MMM-yyyy hh:mm a')
                  : extraLabelValue;
              <p class="text-sm font-semibold text-neutral-900 mt-x-sm">
                {{ viewedExtraLabelValue }}
              </p>
            </div>
          }
        }
      </div>
    }
  </ng-template>
}
